import React from 'react'
import clsx from 'clsx'
import { Link } from 'react-router-dom'
import { Box, Typography, Link as MuiLink } from '@mui/material'
import { Icon } from 'src/components/atoms'
import { Store, Tenant, TenantDetail } from 'src/slices/services/api'
import styles from './styles.module.scss'

export type TenantSalesReportInfoProps = {
  store?: Store
  tenant?: Tenant
  tenantDetail?: TenantDetail
  tenantPath: string
} & React.StyledProps

const getCodeDisplayWidth = (code?: string) =>
  code && code.length >= 10 ? styles.long : ''

const TenantSalesReportInfo: React.StyledFC<TenantSalesReportInfoProps> = ({
  className,
  store,
  tenant,
  tenantDetail,
  tenantPath,
}: TenantSalesReportInfoProps) => {
  return (
    <Box className={clsx(className, styles.root)}>
      <Box className={styles.rightAbove}>
        <MuiLink
          className={styles.pathToDetail}
          component={Link}
          to={tenantPath}
          target="_blank"
        >
          テナント詳細ページへ
          <Icon className={styles.icon} icon="externalLink" />
        </MuiLink>
      </Box>
      <Typography variant="body1" className={styles.title}>
        テナント情報
      </Typography>

      <Typography className={styles.eachInfo} variant="body2">
        <span className={styles.content}>
          <span
            className={clsx(styles.code, getCodeDisplayWidth(tenant?.code))}
          >
            {store?.code}
          </span>
          <span>{store?.name}</span>
        </span>
      </Typography>
      <Typography className={styles.eachInfo} variant="body2">
        <span className={styles.content}>
          <span
            className={clsx(styles.code, getCodeDisplayWidth(tenant?.code))}
          >
            {tenant?.code}
          </span>
          <span>{tenant?.name}</span>
        </span>
      </Typography>
      <Typography className={styles.eachInfo} variant="body2">
        <span className={styles.content}>
          {tenantDetail?.staffTel || ' - '}
        </span>
      </Typography>
    </Box>
  )
}

export default TenantSalesReportInfo
